import { useVoiceCallContext, type VoiceCallContextValue } from "../contexts/VoiceCallContext";

export type { DeviceType, CallStatus } from "../contexts/VoiceCallContext";

export interface UseVoiceCallReturn {
  deviceType: VoiceCallContextValue["deviceType"];
  isReady: boolean;
  isInitializing: boolean;
  isOnCall: boolean;
  isOpen: boolean;
  callStatus: VoiceCallContextValue["callStatus"];
  callDuration: number;
  isMuted: boolean;
  incomingCall: unknown | null;
  errorMessage: string | null;
  mode: VoiceCallContextValue["mode"];
  activePatientId: string | null;
  activePatientName: string | null;
  activePatientPhone: string | null;
  initialize: () => Promise<boolean>;
  openCallPanel: (patientId: string, patientName?: string, patientPhone?: string) => void;
  makeCall: (toNumber: string, patientId: string, patientName?: string, patientPhone?: string) => Promise<void>;
  closeCallPanel: () => void;
  hangUp: () => void;
  toggleMute: () => void;
  acceptIncoming: () => void;
  rejectIncoming: () => void;
  minimize: () => void;
  expand: () => void;
}

interface UseVoiceCallOptions {
  autoInit?: boolean;
}

/**
 * Backward-compatible hook that delegates to VoiceCallContext.
 * The `autoInit` option is ignored since the provider initializes automatically.
 */
export function useVoiceCall(_options?: UseVoiceCallOptions): UseVoiceCallReturn {
  return useVoiceCallContext();
}
